import React, { FC } from 'react';

import { AppCard } from 'components/appComponents';

import { BalanceArea as BalanceAreaType } from 'bus/factory/types';

import './styles.sass';

type Props = {
  balanceArea: BalanceAreaType;
};

const BalanceArea: FC<Props> = ({ balanceArea }) => {
  return (
    <div className="balance-area">
      <div className="balance-area__title">Общий склад</div>
      <AppCard>
        <div className="d-flex">
          {balanceArea.balanceAreaDetails.map((detail) => (
            <div key={detail.materialId} className="pa-2 card_balance d-flex column justify-center align-center">
              <div className="card_balance__title">{detail.material}</div>
              <div>{detail.quantity}</div>
            </div>
          ))}
        </div>
      </AppCard>
    </div>
  );
};

export default BalanceArea;
